import BankerPromoCode from '@domains/banker-promo-code/views/BankerPromoCode.vue'

export default [
  {
    path: 'banker-promo-code',
    component: BankerPromoCode,
    name: 'BankerPromoCode'
  }
]
